<script setup lang="ts">
import { computed } from 'vue'

export interface Props {
  border?: boolean
  cols?: number
  fullWidth?: boolean
  grid?: boolean
  margin?: boolean
  title?: string
  gapX?: number
  gapY?: number
  titleClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  border: false,
  cols: 24,
  fullWidth: true,
  grid: true,
  margin: true,
  gapX: 3,
  gapY: 2.5,
  title: '',
  titleClass: 'font-medium text-base text-black uppercase'
})

const gridCols = computed(() => {
  return {
    6: 'grid-cols-6',
    12: 'grid-cols-12',
    24: 'grid-cols-24'
  }[props.cols]
})

const gapX = computed(() => {
  return {
    3: 'gap-x-3',
    2.5: 'gap-x-2.5',
    2: 'gap-x-2',
    1.5: 'gap-x-1.5',
    1: 'gap-x-1'
  }[props.gapX]
})

const gapY = computed(() => {
  return {
    3: 'gap-y-3',
    2.5: 'gap-y-2.5',
    2: 'gap-y-2',
    1.5: 'gap-y-1.5',
    1: 'gap-y-1'
  }[props.gapY]
})

</script>

<template>
  <div class="not-first:pt-4">
    <div
      v-if="title !== ''"
      class="px-5 pb-1.5 not-first-child:pt-4"
      :class="titleClass"
    >
      <slot name="title">
        {{ title }}
      </slot>
    </div>
    <div
      :class="[ border || title !== '' ? 'border-t border-stone-100' : '', grid ? ['grid 5 m-0 p-0', gapX, gapY] : '', margin ? 'pt-3' : 'not-first:mt-2', grid ? gridCols : '']"
      class="px-5 mb-1 last:mb-3 "
    >
      <slot />
    </div>
  </div>
</template>
